module.exports = __webpack_public_path__ + "img/mes.98918a50.png";